/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Timeline_Title_LeadInputs */

const en_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse photos &`)
};

const es_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora fotos y`)
};

const de_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos &`)
};

const zh_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览照片和`)
};

const ar_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفّح الصور و`)
};

const fr_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourez photos et`)
};

const vi_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt ảnh &`)
};

const sw_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinjari picha na`)
};

const th_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียกดูภาพถ่ายและ`)
};

const bs_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregledajte fotografije i`)
};

const ja_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写真と`)
};

const ko_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사진과`)
};

const pt_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegue por fotos e`)
};

const it_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfoglia foto e`)
};

const sv_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bläddra bland foton &`)
};

const nl_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blader door foto's &`)
};

const da_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemse fotos &`)
};

const nb_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bla gjennom bilder &`)
};

const fi_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selaa kuvia ja`)
};

const pl_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglądaj zdjęcia i`)
};

const ru_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотрите фото и`)
};

const tr_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotoğraflara ve`)
};

const hi_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोटो और`)
};

const id_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi foto &`)
};

const ms_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layari foto &`)
};

const cs_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procházejte fotografie a`)
};

const el_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Περιηγηθείτε σε φωτογραφίες και`)
};

const he_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עיינו בתמונות`)
};

const af_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blaai deur foto's &`)
};

const hu_hof_timeline_title_lead = /** @type {(inputs: Hof_Timeline_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böngésszen fotók és`)
};

/**
* | output |
* | --- |
* | "Browse photos &" |
*
* @param {Hof_Timeline_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_timeline_title_lead = /** @type {((inputs?: Hof_Timeline_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Timeline_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_timeline_title_lead(inputs)
	if (locale === "de") return de_hof_timeline_title_lead(inputs)
	if (locale === "zh") return zh_hof_timeline_title_lead(inputs)
	if (locale === "ar") return ar_hof_timeline_title_lead(inputs)
	if (locale === "fr") return fr_hof_timeline_title_lead(inputs)
	if (locale === "vi") return vi_hof_timeline_title_lead(inputs)
	if (locale === "sw") return sw_hof_timeline_title_lead(inputs)
	if (locale === "th") return th_hof_timeline_title_lead(inputs)
	if (locale === "bs") return bs_hof_timeline_title_lead(inputs)
	if (locale === "ja") return ja_hof_timeline_title_lead(inputs)
	if (locale === "ko") return ko_hof_timeline_title_lead(inputs)
	if (locale === "pt") return pt_hof_timeline_title_lead(inputs)
	if (locale === "it") return it_hof_timeline_title_lead(inputs)
	if (locale === "sv") return sv_hof_timeline_title_lead(inputs)
	if (locale === "nl") return nl_hof_timeline_title_lead(inputs)
	if (locale === "da") return da_hof_timeline_title_lead(inputs)
	if (locale === "nb") return nb_hof_timeline_title_lead(inputs)
	if (locale === "fi") return fi_hof_timeline_title_lead(inputs)
	if (locale === "pl") return pl_hof_timeline_title_lead(inputs)
	if (locale === "ru") return ru_hof_timeline_title_lead(inputs)
	if (locale === "tr") return tr_hof_timeline_title_lead(inputs)
	if (locale === "hi") return hi_hof_timeline_title_lead(inputs)
	if (locale === "id") return id_hof_timeline_title_lead(inputs)
	if (locale === "ms") return ms_hof_timeline_title_lead(inputs)
	if (locale === "cs") return cs_hof_timeline_title_lead(inputs)
	if (locale === "el") return el_hof_timeline_title_lead(inputs)
	if (locale === "he") return he_hof_timeline_title_lead(inputs)
	if (locale === "af") return af_hof_timeline_title_lead(inputs)
	if (locale === "hu") return hu_hof_timeline_title_lead(inputs)
	return en_hof_timeline_title_lead(inputs)
});